<main class="main main-marketplace">
  @if (breedingOrders && ((breedingOrders.length != 0) || (breedingOrders.length == 0))) {
  <section class="list marketplace">
    <div class="container">
      <div class="marketplace__inner animate-fade-scale" [class.animate-in]="animateIn">
        <div class="list__inner" style="overflow-y: auto;">
          @for (breedingOrder of breedingOrders; track breedingOrder; let i = $index) {
          <div class="list__item breeding-order-item" [style.--stagger]="i">
            <div class="breeding-order-card">
              <div class="breeding-order-card__creatures">
                <div class="breeding-order-card__creature">
                  <div class="breeding-order-card__img-wrap">
                    <img [src]="breedingOrder.creature1.imageUrl" alt="c1" />
                  </div>
                  <div class="breeding-order-card__meta">
                    <div class="breeding-order-card__id">#{{breedingOrder.creature1.nftTokenId}}</div>
                    <div class="breeding-order-card__rarity rarity"
                      [ngClass]="{'common': breedingOrder.creature1.rarity == rarityType.Common, 'rare': breedingOrder.creature1.rarity == rarityType.Rare, 'legendary': breedingOrder.creature1.rarity == rarityType.Legendary}">
                      {{breedingOrder.creature1.rarity | rarityName | translate}}</div>
                  </div>
                </div>
                <div class="breeding-order-card__plus">+
                  <div class="breeding-order-card__line"></div>
                </div>
                <div class="breeding-order-card__creature">
                  <div class="breeding-order-card__img-wrap">
                    <img [src]="breedingOrder.creature2.imageUrl" alt="c2" />
                  </div>
                  <div class="breeding-order-card__meta">
                    <div class="breeding-order-card__id">#{{breedingOrder.creature2.nftTokenId}}</div>
                    <div class="breeding-order-card__rarity rarity"
                      [ngClass]="{'common': breedingOrder.creature2.rarity == rarityType.Common, 'rare': breedingOrder.creature2.rarity == rarityType.Rare, 'legendary': breedingOrder.creature2.rarity == rarityType.Legendary}">
                      {{breedingOrder.creature2.rarity | rarityName | translate}}</div>
                  </div>
                </div>
              </div>

              <div class="breeding-order-card__progress">
                <div class="breeding-order-card__status" [ngClass]="{
                    'pending': breedingOrder.breedingOrder.status === 1,
                    'executed': breedingOrder.breedingOrder.status === 2,
                    'cancelled': breedingOrder.breedingOrder.status === 3
                  }">
                  <span *ngIf="breedingOrder.breedingOrder.status === 1">Pending</span>
                  <span *ngIf="breedingOrder.breedingOrder.status === 2">Done</span>
                  <span *ngIf="breedingOrder.breedingOrder.status === 3">Cancelled</span>
                </div>
                <div class="breeding-order-card__bar" style="background: #333; height: 10px; border-radius: 5px; overflow: hidden;">
                  <div class="breeding-order-card__bar-fill" 
                       [style.width.%]="getProgress(breedingOrder)"
                       [style.background]="'linear-gradient(90deg, #f6a425 0%, #ffcc66 20%, #c27f56 55%, #9a5d34 80%, #76482c 100%)'"
                       style="height: 100%; transition: width 0.5s ease;"></div>
                </div>
                <!-- Debug info (remove in production) -->
                <div style="font-size: 10px; color: #fff; margin-top: 2px; background: rgba(0,0,0,0.7); padding: 2px;">
                  Progress: {{getProgress(breedingOrder)}}% | {{breedingOrder.breedingOrder.id}}
                </div>
                <div class="breeding-order-card__time">
                  {{breedingOrder.breedingOrder.createdAt | date : 'medium'}}
                </div>
              </div>

              <div class="breeding-order-card__actions">
                <a class="button button-secondary" target="_blank" rel="noopener"
                  [href]="getTxLink(breedingOrder.breedingOrder.transactionHash)">Transaction</a>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </section>
  } @else if (breedingOrders && breedingOrders.length == 0) {
  <empty-page-component></empty-page-component>
  } @else {
  <section *ngIf="showLoading" class="loader-box">
    <span class="loader"></span>
  </section>
  }
</main>